module.exports = __webpack_public_path__ + "img/architecture-1-400x300.2ee2051f.jpg";